"use client";
import React from "react";
// import styles from "./career-promises.module.scss";
import Image from "next/image";
import { parseHtml, toWebp } from "@/utils/common";

interface CareerPromisesProps {
  data?: any;
}

const PromisesMobile = ({ data }: CareerPromisesProps) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL || "";
  return (
    <>
      {/* relative lg:hidden block */}
      <div className="relative hidden ">
        {data?.Card?.map((item: any, i: number) => {
          const isImageBg = i % 2 === 0;
          const isFourth = i % 3 === 0;
          const imageUrl = item?.image?.data?.attributes?.url
            ? toWebp(`${baseUrl}${item?.image?.data?.attributes?.url}`)
            : "";

          // ✅ set shape url conditionally
          const beforeShape = `/images/career-bg-shape-${!isFourth ? 2 : 4}.png`;
          const overlayShape = `/images/career-bg-shape-${!isFourth ? 3 : 5}.svg`;

          return (
            <div
              key={"card" + (i + 1)}
              className={`animated-scroll-1 relative overflow-hidden mb-[60px] min-h-[420px] xl:min-h-[528px] ${
                isImageBg
                  ? "shadow-[0px_16px_72px_-10px_rgba(0,26,45,0.24)]"
                  : `z-[0] before:content-[''] ${!isFourth ? "bg-[#E6F3FD]" : "bg-[#F3F8E6]"}`
              }`}
              // ✅ inline style for pseudo-like background
              style={
                !isImageBg
                  ? {
                      position: "relative",
                    }
                  : {}
              }
            >
              {/* pseudo background handled via extra span */}
              {!isImageBg && (
                <span
                  className="absolute top-0 left-0 w-full h-full -z-[2]"
                  style={{
                    backgroundImage: `url(${beforeShape})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "100% 100%",
                    backgroundColor: "#F0F8FF",
                  }}
                />
              )}

              {isImageBg ? (
                <>
                  <Image
                    src={imageUrl}
                    alt={item?.title || "career promise"}
                    width={705}
                    height={528}
                    className="object-cover w-full h-[420px] xl:h-[528px]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/40 to-black/20"></div>
                </>
              ) : (
                <div>
                  <div className="absolute right-0 bottom-0">
                    <Image
                      src={overlayShape}
                      alt="promise shape"
                      width={191}
                      height={94}
                      className="object-cover w-auto h-auto"
                    />
                  </div>
                </div>
              )}

              {/* Dots */}
              {[
                "top-[12px] left-[12px]",
                "top-[12px] right-[12px]",
                "bottom-[12px] left-[12px]",
                "bottom-[12px] right-[12px]",
              ].map((pos, idx) => (
                <span
                  key={idx}
                  className={`absolute ${pos} z-10 shadow-[0_3px_6px_0_#00000033] bg-white rounded-full w-[10px] h-[10px]`}
                />
              ))}

              {/* Content */}
              <div
                className={
                  isImageBg
                    ? "absolute top-0 md:p-[32px_24px] p-[32px_24px] z-1"
                    : "md:p-[32px_24px] p-[32px_24px] z-1"
                }
              >
                <h2
                  className={`line-clamp-1 xl:text-[32px] xl:leading-[41.6px] md:text-[24px] md:leading-[31.2px] text-[22px] leading-[28.6px] pb-[24px] font-[700] ${
                    !isImageBg ? " text-[#040405]" : " text-white"
                  }`}
                >
                  {item?.title}
                </h2>
                <div
                  className={`lg:text-[18px] lg:leading-[25.2px] text-[16px] leading-[22.4px] mb-[16px] font-[600] ${
                    isImageBg ? "text-white" : "text-[#32343B]"
                  }`}
                >
                  {parseHtml(item?.text)}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
export default PromisesMobile;
